/* tslint:disable:max-line-length */
const NOT_REGEX_ERROR = 'Los caracteres "<" y ">" están prohibidos';

const messages = {
  common: {
    phoneInput: 'Número de teléfono',
  },
  cells: {
    cellSizeSmall: 'compartimiento pequeño',
    cellSizeMedium: 'compartimiento mediano',
    cellSizeLarge: 'compartimiento grande',
    unknown: '',
  },

  infoSaveMoney: {
    title: "Consigue dinero",
    text1: "Acumula 1€ por cada paquete recibido hasta un total de 10€.",
    text2: "Al tener 10€ en la hucha, Smart Point Girona se pondrá en contacto contigo para hacerte el ingreso bancario.",
  },

  types: {
    crosstownRecipient: 'Enviar a un amigo (destinatario)',
    crosstownSender: 'Enviar a un amigo (remitente)',
    crosstown: 'Enviar a un amigo',
    clickCollect: 'Click & collect',
    returns: 'Devoluciones',
    external: 'Recibir paquetes',
    publicDelivery: 'Recibir paquetes',
    unknown: 'error',
    100: 'Envia a un amigo',
    200: 'Recibir paquetes',
    300: 'Click & Collect',
    400: 'Devoluciones',
  },

  status: {
    status: "Estado",
    waitingActionRecipient: "Esperando acción del destinatario",
    waitingActionSender: "Esperando acción del remitente",
    readyToPickUp: "Listo para recoger",
    waitingOrderDestination: "Esperando destino del pedido",
    inProgress: "Envio en proceso",
    completed: "Completado",
    unknown: 'error',
    0: 'Descartado',
    90: 'Completado',
    10: 'Nuevo',
    20: 'Esperando paquete',
    30: 'Esperando recogida',
    70: 'En entrega',
    50: 'Procesando',
    80: 'Paquete en Smart Point',
  },

  history: {
    title: "Historial",
  },

  statusCallToAction: {
    awaitingDropoffSender: 'Coloca el paquete en el Smart Point para comenzar',
    awaitingPickupRecipient: 'El envío está listo, dirígete al Smart Point',
    awaitingHubSelectionRecipient: 'Para recibir tu envío, selecciona un destino',
  },

  dialogExternal: {
    title: "Recibir paquetes",
    intro: "Recibe tus paquetes gratis en menos de 24 horas, en puntos de entrega Cero Emisiones repartidos por toda la ciudad",
    list1: 'Cuando compres online utiliza esta dirección de envío',
    list2: 'Una vez llegue el paquete a nuestro almacén lo llevaremos al Smart Point que elijas',
    list2_2: 'Una vez llegue el paquete a nuestro almacén lo llevaremos a tu Smart Point',
    list2Button: 'Elige Smart Point',
    list2ButtonAlt: 'Elige otro Smart Point',
    list3: 'Recibirás un sms con el enlace para abrir el Smart Point cuando el paquete esté listo',
  },

  dialogNotAvailable: {
    title: "No disponible",
    text: "Actualmente esta opción no está disponible",
  },

  serviceInterruption: {
    title: "Aviso Importante",
    text: "Para dar un paso adelante hacemos mantenimiento\n",
    text2: "INTERRUPCIÓN TEMPORAL DEL SERVICIO DE ENTREGA GRATUITA.\n",
    text3: "Relanzaremos el servicio con nuevas funcionalidades en breve.",
  },

  dialogShipmentInfo: {
    orderNumber: "Número de pedido",
    createdAt: "Creado",
    type: "Tipo",
    sent: "Enviado",
    recipient: "Receptor",
    sender: "Remitente",
    status: "Estado",
    address: "Direccion",
    note: "Nota del remitente",
    selectOriginText: "para iniciar el envío, selecciona un origen",
    selectOriginButton: "Seleccionar origen",
    selectDestinationText: "Para recibir el envío, selecciona un destino",
    selectDestinationButton: "Seleccione Destino",
    waitingRecipientText: "Esperando que el destinatario selecciona un destino",
    yourOrderInHubText: "El paquete está listo, dirigete al Smart Point",
    openHub: "Abrir SmartPoint",
    selectHub: "Seleccionar SmartPoint",
    deliveringText: "Entrega en proceso",
  },

  dialogShipmentCancel: {
    title: 'Borrar envio',
    text: "No podrás deshacer esta acción",
    delete: "Borrar",
    cancel: "Cancelar",
  },

  dropupNotifications: {
    youHaveXNotif: "Tienes {numNot} notificaciones",
    youHave1Notif: "Tienes 1 notificación",
    youHaveNoNotif: "No tienes notificaciones",
  },

  cards: {
    from: "de: {phone}",
    to: "a: {phone}",
    copied: "copiado",
    address: "Dirección",
    selectDefaultDestination: "selecciona Smart Point por defecto",
    note: "Nota del remitente",
    noteOwn: "Note al destinatario",
    toBeDelivered: 'para entregar',
    deliveryInProgress: 'entrega en proceso',
    inLocker: 'listo para recoger',
    openHub: 'ABRIR SMART POINT',
    selectDestination: 'Para recibir el envío selecciona un destino',
    changeLocalization: 'CAMBIAR LOCALIZACIÓN',
    emptyActiveOrderList: 'No hay nada aquí<br/>¡Crea un nuevo envío!',
    selectDestinationHub: 'SELECCIONAR DESTINO',
    awaitingDropoff: 'Para iniciar el envío deja el paquete en el Smart Point',
    awaitingPickup: `Ya puedes recoger tu envío en el Smart Point`,
    toBePickedUp: 'Estamos esperando a que el destinatario recoja su envío',
    sendAt: "Enviado en:",
    // sendToAFriendOutgoing: `Envía a un amigo`,
    sendToAFriendOutgoing: `Envía a `,
    // sendToAFriendIncoming: `Envío de un amigo`,
    sendToAFriendIncoming: `Envío de `,
    externalIncoming: 'Tienes un paquete',
    amazonReturns: 'Devoluciones de Amazon',
    publicDelivery: 'Tienes un paquete',
    clickCollectIncoming: 'Tienes un paquete',
  },

  officeAddress: 'Centro {code}, {address}',

  selectDefaultDestination: {
    selectDefaultFooter: `Elige tu Smart Point favorito.<br> Tus pedidos llegaran a este Smart Point por defecto`,
    selectDefaultFooterSingleHub: `Este es tu Smart Point.<br> Tus pedidos llegaran aquí`,
    createDeliveryAddress: 'GENERAR DIRECCIÓN DE ENTREGA',
    addressHelper: 'Has seleccionado el Smart Point ubicado en',
    selectOtherHub: 'SELECCIONA OTRO SMART POINT',
    addressExplanation: 'COPIA Y PEGA ESTA DIRECIÓN EN CUALQUIER TIENDA PARA RECIBIR TU PEDIDO EN EL SMART POINT ' +
      'ESCOGIDO.',
    smsWarning: 'TE AVISAMOS POR SMS',
    copyAddress: 'PULSA PARA COPIAR LA DIRECCIÓN',
    shippingNote: 'GENERA TU DIRECCIÓN Y CUANDO RECIBAMOS TU PEDIDO LO VERÁS AQUI',
    shippingButton: 'GENERAR DIRECCIÓN DE ENTREGA',
  },

  buttons: {
    next: 'SIGUIENTE',
    send: "ENVIAR",
    loadMore: `CARGAR MÁS`,
    ok: 'DE ACUERDO',
    reopen: 'ABRIR OTRA VEZ',
    tryAgain: 'VOLVER A INTENTAR',
    cancel: 'CANCELAR',
    done: 'HECHO',
    getStarted: 'EMPEZAR',
    finish: 'TERMINAR',
    receiverPhone: "TELÉFONO DEL RECEPTOR",
    dropOffLocTime: "UBICACIÓN DE ENTREGA",
    confirm: "CONFIRMAR",
    update: "Actualizar",
    pressAndHold: "PULSA<br/> Y<br/>DEJA",
    copied: "COPIADO",
  },

  haveYouOrder: {
    question: {
      text: '¿YA HAS HECHO TU PEDIDO?',
    },
    answer: {
      title: '¡GENIAL!',
      text: 'Recibirás un SMS con más información sobre la recogida y aparecerá aquí',
    },
  },

  shipmentListTabs: {
    incoming: 'Recibido',
    outgoing: 'Enviado',
  },

  inputAndButtons: {
    search: "Buscar",
    radioDontShow: "No mostrar de nuevo mensajes de ayuda aquí",
  },

  // general errors
  errors: {
    validation: "Esta opción esta deshabilitada hasta que valides tu número de teléfono",
    verification_code: 'Ha habido un problema en la verifiación. Estas seguro que la URL es la correcta?',
    required: 'Debes rellenar este campo',
    unknown: "Ups, ha ocurrido algo inesperado.",
    contact: "Por favor, contacta con nosotros",
    smsLimitReach: "Nuestras lineas telefonicas estan ocupadas, pruebe más tarde o contacte con nosotros",
    shipment_load_error: "Ha habido un problema cargado este pedido",
    shipment_history_error: "Ha habido un problema cargado el historial",
    general: {
      string: 'Mínimo {0} caracteres',
      required: 'Este campo es obligatorio.',
      confirmed: 'Las contraseñas no coinciden.',
      email: 'Por favor introduce un email válido.',
      noCell: 'Lo sentimos, este hub no tiene compartimentos disponibles en este momento.',
      cellWontOpen: '¡Uau! Se produjo un error al intentar abrir el compartimento. Por favor inténtalo de nuevo o más tarde.',
      not_regex: NOT_REGEX_ERROR,
      validation: {
        phone: 'Por favor introduce un número de teléfono válido.',
      },
    },

  },

  // Options

  dropUp: {
    uniqueAddressLabel: 'DIRECCIÓN DEL CENTRO DE REPARTO',
    uniqueAddressLabel2: 'REALIZA EL PEDIDO PEGANDO ESTA DIRECCIÓN EXACTA PARA RECIBIR EL PAQUETE EN EL PUNTO DE RECOGIDA A SELECCIONAR',
    selectOption: "SELECCIONA UNA OPCION",
    copied: 'Dirección copiada en el portapapeles',
    hubsButton: "VER TODOS LOS PUNTOS DE RECOGIDA",
    crossTownDelivery: "ENVÍOS POR LA CIUDAD",
    o: 'o',
    selectLockerSize: 'TAMAÑO DE COMPARTIMENTO',
  },

  drawer: {
    userMenu: {
      myProfile: "MI PERFIL",
      defaultHub: `MI SMART POINT`,
      euroSaved: "ACUMULADOS: ",
      ceo2Saved: "{co2} KG de Co2 ahorrados",
      history: 'HISTORIAL',
      howItWorks: "CÓMO FUNCIONA",
      clickCollect: "CLICK&COLLECT PLUS",
      clickCollectLink: "https://smartpoint.city/es/click-es/",
      language: "IDIOMA",
      signOut: "CERRAR SESION",
      crossTownDelivery: "ENVÍA A UN AMIGO",
    },
  },

  // pages

  home: {
    co2Saved: 'CO2 AHORRADO',
    validationMsg: "Esta cuenta no ha sido validada. Algunas de las opciones no estarán disponibles.",

    buttons: {
      buttonExternal: 'RECIBIR PAQUETES',
      buttonClickCollect: 'CLICK & COLLECT',
      buttonClickCollectCi: 'EL CORTE INGLÉS C&C',
      buttonCrosstown: 'ENVIA A UN AMIGO',
      buttonReturns: 'DEVOLUCIONES',
    },
  },

  callUs: `PROBLEMS? CALL US`,

  shipmentNotes: {
    title1: "DESCRIBE LO QUE ESTÁS ENVIANDO",
    placeholder: "¿Qué estás enviando?",
  },

  crosstownLoading: {
    title: 'UN MOMENTO POR FAVOR',
    comment: "Estamos en ello",
    finishText: "Hemos reservado un <b>{hubSize}</b> en <b>{hubAddress}</b> donde podrás dejar tu paquete",
    openHubBtn: "ABRIR HUB AHORA",
    goBackBtn: "HACERLO MÁS TARDE",
  },

  deliverySummary: {
    title: "Resumen de tu envío",
    phone: "Número de teléfono del destinatario",
    dropoff: "Entrega",
    size: "Tamaño",
    deliveryLocation: "Lugar de entrega",
    weTakeCare: "¡No te preocupes, nosotros nos encargamos!",
    payment: "Pago",
    note: "Nota",
    confirmation: "Por favor confirma que toda la información de arriba es correcta",
    phoneDisclaimer: "El receptor verá tu número de teléfono",
    // leaving here as reference
    errors: {
      sameUser: 'No tiene sentido que te envíes un paquete a ti mismo',
    },
  },

  registerOnboarding: {
/// ******
    onboarding1: {
      text1: `<b class="xl">Te damos la bienvenida a Smart Point Girona</b>`,
      text2: `Un sistema único para recibir tus paquetes en puntos inteligentes repartidos por toda la ciudad`,
    },

    onboarding2: {
      text1: ``,
      text2: `<b>Cuando hagas tus compras online indica la dirección de entrega la ubicación de nuestra central` +
        ` logística:</b>`,
    },

    onboarding3: {
      text1: '',
      text2: `<b>Una vez recibamos tu paquete te lo notificaremos con un mensaje y te pediremos que elijas un` +
        ` Smart Point para recogerlo</b>`,
    },

    onboarding4: {
      text1: ``,
      text2: `<b>Nosotros nos encargamos de dejar tu paquete en Smart Point y te avisaremos cuando esté ` +
        ` disponible</b>`,
    },
  },

  intro: {

    login: {
      title: 'INICIAR SESIÓN',
    },

    register: {
      title: 'REGISTRO',
      registerUpText: "Introduce tus datos para registrarte",
      loginUpText: "Introduce tus datos para iniciar sesión",

      registerDownText: '¿Ya tienes un perfil?',
      registerLink: 'Registro',

      loginDownText: "¿No tienes una cuenta?",
      loginLink: 'Iniciar sesión',
    },

    done: {
      text1: "La primera app de envíos y devoluciones de Emisión Cero para tus compras online",
      text2: "No volverás a tener problemas con tus pedidos",
    },
  },

  sendReset: {
    text: "Introduce tu teléfono y te enviaremos un SMS en donde podras acceder al enlace de recuperación",
    back: "Volver al inicio de sesión",
    button: "Enviar",
    success: "Hemos enviado un SMS al teléfono que nos has indicado",
  },

  reset: {
    title: "Cambiar contraseña",
    text: "Introduce tu email y la nueva contraseña para poder cambiarla",
    back: "Volver al inicio de sesión",
    password: "Nueva contraseña",
    button: "Cambiar contraseña",
    success: "Tu contraseña ha sido cambiada correctamente",
    errors: {
      401: `Ha habido un problema cambiando la contraseña`,
    },
  },

  validationView: {
    title: 'Validación de usuario',
    text: "Espera un momento mientras validamos tu cuenta",
    back: "Volver al inicio de sesión",
    result: "Tu cuenta ha sido validada satisfactoriamente",
    error: "Ha habido un error al validar tu cuenta",
    errors: {
      cantValidate: 'Tu cuenta no ha podido ser validada',
    },
  },


  registerForm: {
    namePlaceholder: "Nombre...",
    lastNamePlaceholder: "Apellidos...",
    phonePlaceholder: "Teléfono...",
    emailPlaceholder: "Email...",
    passwordPlaceholder: "Contraseña...",
    passwordCreationPlaceholder: "Crea tu contraseña...",
    rePasswordCreationPlaceholder: "Repite tu contraseña...",
    resendVerificationText: "Esta cuenta ya esta registrada y necesita validarse",
    resendVerificationButton: "Enviar enlace de validación",
    resendVerificationSuccess: "Enlace de validación enviado via SMS",
    tos_text: 'Acepto los',
    tos_link_text: 'términos y condiciones de uso',

    errors: {
      409: 'Parece que ya estás registrado.',
      not_regex: NOT_REGEX_ERROR,
    },
  },

  loginForm: {
    forgotPassword: 'Olvidé mi contraseña',
    errors: {
      401: "Parece que no podemos reconocerte. ¿Quizás has olvidado tu contraseña?",
      not_regex: NOT_REGEX_ERROR,
    },
  },

  tos: {
    title: 'Terminos y condiciones de uso',
    text: '<h4>Condiciones Generales de Entrega</h4>' +
        '    <p>Estos datos son requeridos para la correcta gestión de la custodia temporal y entrega de mercancías y servicios, y sus datos están protegidos en cumplimiento del Reglamento General de Protección de Datos (RGPD) (UE) 2016/679 y de la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos de Carácter Personal y Garantía de los Derechos Digitales (LOPD y GDD), de protección de datos de carácter personal.</p>' +
        '    <h4>Aspectos Generales</h4>' +
        '    <p>El servicio incluye la recogida, custodia temporal y entrega de mercancías y servicios, conforme al servicio y plazos acordados, en el terminal seleccionado dentro de la red de taquillas inteligentes de Lava Locker S.L. bajo la marca Smart Point City (en adelante ‘Smart Point City’), que puede incluir el nombre de la ciudad donde opera.</p>' +
        '    <h4>Sistema de entregas y recogidas y Marketplace: Proceso</h4>' +
        '    <p>Todos los Usuarios tendrán asignado un código único de entrega, que les permite recibir entregas en el ‘Smart Point City’. Para cada entrega recibida, el usuario recibirá un código de recogida vía email y SMS, siempre que el registro se complete con un número móvil válido, que necesitará introducir en la aplicación web https://w.smartpoint.city/w/#/ , para la retirada de la mercancía de la taquilla dentro del plazo máximo de recogida, que es de 10 días si no se informa lo contrario. Es responsabilidad del usuario la custodia de dicho código único de entrega y de los códigos de recogida personales, pudiendo éste cederlos a un tercero para la recepción o envío de un paquete. LAVA LOCKER, S.L. no se hace responsable del uso de dicho código.<br> Para la modalidad de recepción de entregas las dimensiones máximas que deberán cumplir los envíos para poder realizar la entrega en Smart Points, dependerá de la tipología de los compartimentos (de pequeño a grande): <br> <br> Pequeño: 40 cm ancho x 7 cm alto x 50 cm fondo <br> Mediano: 40 cm ancho x 18 cm alto x 50 cm fondo <br> Grande: 40 cm ancho x 29 cm alto x 50 cm fondo <br> <br> En caso de recepción de paquetes con medidas superiores, no podrán ser entregados en los Smart Point. El usuario recibirá indicaciones para la recogida de paquetes en la oficina de Smart Point sin coste, con la siguiente excepción: para paquetes con medida superior a los 75 centímetros en alguna de sus dimensiones, la custodia para su recogida en oficina tendrá un coste de 1€ por cada 5kg de mercancía a abonar por el usuario previamente a su recogida. Además, Smart Point ofrecerá para paquetes con medidas superiores a las dimensiones máximas la alternativa de entrega a domicilio, con un coste asociado. <br> <br> Smart Point se exime ante el usuario de cualquier responsabilidad en cuanto al cumplimiento de los plazos de entrega comprometidos por no disponibilidad de huecos acordes al tipo de mercancía a entregar en la taquilla seleccionada, siendo responsabilidad del transportista que realiza la entrega. Asimismo, no se responsabiliza de daños, tanto en el embalaje como en contenido en su fase de transporte en los que otros operadores puedan haber incurrido. <br> Para el uso de los servicios disponibles en el Marketplace de Smart Point: el usuario tendrá que realizar su pedido a través de la aplicación https://w.smartpoint.city/w/#, dejando su/s artículo/s en el compartimento correspondiente cuando sea necesario.  Los precios de los servicios están detallados en la información de cada servicio en la aplicación web. Los precios de cada servicio pueden ser modificados sin notificación. Si no hay un precio especificado para un servicio y no se notifica de lo contrario, como por ejemplo la necesidad de preparación de un presupuesto, el servicio es gratuito. Una vez realizado un pedido, se enviará una confirmación del mismo por email y SMS, a partir de la cual el precio no podrá ser modificado. El usuario recibirá también un enlace o será redirigido a la página correspondiente para pagar el importe. Si el pedido requiere devolver algún artículo al usuario, se le entregarán de nuevo en el Smart Point. <br></p>' +
        '    <h4>Custodia temporal de paquetes</h4>' +
        '    <p>Al darse de alta en este servicio el usuario autoriza a LAVA LOCKER S.L. a la custodia temporal de aquellos paquetes que se le entreguen al Smart Point con su código de entrega de usuario o como parte de un proceso de pedido.</p>' +
        '    <h4>Verificación de la naturaleza</h4>' +
        '    <p>Smart Point se reserva el derecho de verificar la naturaleza y el contenido de los paquetes que le han sido confiados, incluyendo la utilización de rayos X, así como interrumpir todo proceso de entrega ya iniciado si apareciera un contenido que infrinja las disposiciones en vigor. Se reserva el derecho de fotografiar los paquetes que son depositados en sus taquillas inteligentes con el fin de demostrar su estado ante hipotéticas futuras reclamaciones; así como de realizar las grabaciones de sus terminales y las operaciones a fin de garantizar la correcta prestación del servicio, su seguridad y correcta utilización.</p>' +
        '    <h4>Mercancía Excluida</h4>' +
        '    <p>Queda prohibido el depósito de paquetes u objetos cuyo contenido sea contrario a la ley o el orden público, incurriendo el cliente en las correspondientes responsabilidades, y quedando LAVA LOCKER, S.L. totalmente exonerada de las mismas por esta causa. Queda prohibido el depósito de armas, réplicas de armas, munición, artículos robados, sustancias venenosas o infecciosas, dinero en metálico, pagarés, moneda, cheques, acciones o participaciones, oro, plata en lingotes, sellos salvo estando franqueados, muestras biológicas, restos humanos, joyas, materiales tóxicos, drogas, animales y materiales inflamables o peligrosos. <br> Smart Point no admitirá entregas con servicio contra reembolso, aquellos que tengan necesidad de pago de aduanas o aquellos que requieran de cualquier pago adicional. Finalmente, tampoco se admitirán bultos de más de 50 kg.</p>' +
        '    <h4>Política de devolución del importe</h4>' +
        '    <p>El usuario tiene derecho a la devolución del importe de su pedido realizado en el Marketplace en el caso que informe por correo electrónico a Smart Point de su deseo de una devolución, antes de que el servicio haya sido realizado. En caso contrario, no habrá devolución disponible. El cliente recibirá un email de confirmación del importe del servicio antes de comenzar el trabajo. Las cancelaciones se tienen que informar por escrito, enviando un correo electrónico a hola@smartpoint.city. No se aceptarán cancelaciones informadas por ninguna otra vía.</p>' +
        '    <h4>Política de cancelación</h4>' +
        '    <p>Smart Point se reserva el derecho a cancelar un pedido si no puede realizar dicho pedido. En caso que el pedido requiriera procesar un ítem que el usuario hubiera depositado en el Smart Point, el ítem será entregado en la taquilla Smart Point correspondiente sin haber sido procesado y el usuario recibirá un email y SMS con un código de acceso para recogerlo.</p>' +
        '    <h4>Días y horarios de prestación de servicios</h4>' +
        '    <p>El servicio de recepción y entrega a los Smart Points es de Lunes a Viernes laborables de 09:00 a 18:00. Una vez realizado el transporte a los Smart Points las taquillas Smart Point City ofrecen un servicio de depósito veinticuatro (24) horas, los siete (7) días de la semana. Este horario puede sufrir alteraciones en función de la accesibilidad de la ubicación en que se encuentre el terminal Smart Point, así como por causas ajenas a Smart Point, como fallos en la cobertura de redes móviles o eléctricas, quedando la prestación del servicio de entrega supeditado a éstas.</p>' +
        '    <h4>Formas de Pago</h4>' +
        '    <p>Los pagos por los servicios prestados se pueden realizar con cualquier tipo de tarjeta de crédito o débito, siempre que esta sea aceptada por el proveedor de métodos de pago de Smart Point. Smart Point no tiene acceso ni almacena datos sensibles relativos al medio de pago utilizado por el Usuario/Cliente. Únicamente la entidad correspondiente procesadora del pago (proveedor de métodos de pago) tiene acceso a estos datos a modo de gestión de los pagos y cobros. Los pagos serán capturados al momento en que el usuario entre en la página web para verificar el pago pendiente o automáticamente en el caso de que sus datos hayan sido guardados con anterioridad con la entidad procesadora del pago.</p>' +
        '    <h4>Daños consecuenciales lucro cesante</h4>' +
        '    <p>LAVA LOCKER, S.L. o la empresa arrendataria del terminal no serán responsables por daños consecuenciales o extraordinarios, ni por lucro cesante, incluyendo pérdida de ingresos, beneficios o mercados, pérdida de imagen, daños producidos por la imposibilidad de utilización de los contenidos en los paquetes, ni por pérdida de oportunidad de negocio o cualquier otra pérdida indirecta que se derive de la pérdida, daño, retraso, entrega incorrecta o falta de entrega del paquete.</p>' +
        '    <h4>Condiciones del seguro</h4>' +
        '    <p>Indemnización máxima por la pérdida o avería de las mercancías transportadas y custodiadas: los límites de indemnización por pérdidas o averías de las mercancías transportadas y/o custodiadas, son los siguientes, conforme al art. 57 LCTT: 1/3 del IPREM diario por kilogramo, lo que implica una indemnización máxima de 6,2767.€/kg, exclusivamente por el periodo que el bulto permanece dentro de los compartimentos del Smart Point. <br> El seguro se aplicará exclusivamente a mercancías. Las expediciones de documentación son asegurables por el valor de la impresión y no por el valor de creación o realización. La indemnización de la mercancía usada, en caso de pérdida total, sufrirá la depreciación correspondiente a su valor actual, y en el caso de rotura parcial de la mercancía se indicará lo dispuesto por la tasación del desperfecto.</p>' +
        '    <h4>Plazo de reclamación</h4>' +
        '    <p>Para una correcta gestión en la tramitación de los seguros, la reclamación de cualquier daño o perjuicio detectado en la mercancía objeto de custodia o entrega en una taquilla inteligente de Smart Point deberá realizarse por correo electrónico hola@smartpoint.city en un plazo máximo de siete (7) días, a contar desde el momento pactado de la entrega. <br> Smart Point no forma parte de la relación contractual entre el usuario y el Courier o Retailer en una recepción de paquetería. El derecho de desistimiento o reclamación que, en su caso, corresponda al usuario en su condición de consumidor, deberá ser ejercitado ante la empresa con la que haya sido adquirido el producto o servicio para ser depositado en la taquilla inteligente.</p>' +
        '    <h4>Protección de Datos</h4>' +
        '    <p>En cumplimiento de lo establecido en el Reglamento General de Protección de Datos (RGPD) (UE) 2016/679 y en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos de Carácter Personal y Garantía de los Derechos Digitales (LOPD y GDD) le informamos que los datos facilitados por usted, así como los generados por la prestación del servicio por parte de Smart Point a sus clientes, serán incorporados a la base de datos de la compañía, para la correcta gestión de la entrega y posterior información de promociones realizadas. La legitimación será en base a la ejecución de un contrato, interés legítimo y el cumplimiento de obligaciones legales. <br> <br> Los datos serán conservados durante el tiempo necesario para una correcta prestación del servicio, así como durante los plazos establecidos por el cumplimiento de obligaciones legales. Además, no se prevén cesiones de datos personales a terceros, salvo las necesarias para la correcta prestación del servicio cumpliendo con los debidos compromisos de confidencialidad con cada uno de nuestros proveedores o colaboradores. <br> <br> Usted puede ejercitar los derechos de acceso, rectificación, supresión u olvido, limitación, oposición, portabilidad. Para ello podrá enviar un email a dpo@lavalocker.es, o bien dirigir un escrito a Lava Locker S.L., en Calle Ramon Turró nº5 - 08005 - Barcelona - BARCELONA, adjuntando copia de su DNI. Asimismo, el interesado puede dirigirse a la Autoridad de Control en materia de Protección de Datos competente (AEPD, en España) para obtener información adicional o presentar una reclamación, así como también puede contactar con nuestro Delegado de Protección de datos (ExpertosLOPD S.L.), en Calle Juan Flórez, 146, 15005, A Coruña o email: <br> <br> dpd@expertoslopd.es. Para más información, puede consultar la política de privacidad del responsable en https://smartpoint.ai/politica-de-privacidad.</p>' +
        '    <h4>Uso de Cookies</h4>' +
        '    <p>http://smartpoint.city, https//w.smartpoint.city/w/#/, http://mayordomo.io y http://smartpoint.ai podrán utilizar cookies durante la presentación del servicio del sitio web. Estas cookies corresponden a pequeños archivos de texto que contienen información y que los sitios web envían al ordenador del Cliente/Usuario cuando está navegando por los mismos. <br> En caso de que las tecnologías empleadas no sean estrictamente necesarias para el correcto funcionamiento del servicio, estas no se ejecutarán sin el previo consentimiento del Usuario.</p>' +
        '    <h4>Propiedad intelectual e industrial</h4>' +
        '    <p>Todos los derechos de propiedad intelectual e industrial sobre la web, la aplicación web y sus contenidos, entre los que se incluye la programación, el diseño, aplicaciones, los gráficos, los códigos, texto o imágenes, las marcas, nombres comerciales, signos distintivos y demás elementos allí presentes pertenecen en exclusiva a LAVA LOCKER S.L. Cualquier reproducción, distribución, comunicación pública (incluida la puesta a disposición), transformación o cualquier otra forma de explotación, ni tan siquiera citando las fuentes, queda prohibida, salvo que se cuente con el consentimiento previo, expreso y por escrito de LAVA LOCKER S.L.</p>' +
        '    <h4>Hojas de reclamación</h4>' +
        '    <p>EXISTEN HOJAS DE RECLAMACIONES A DISPOSICIÓN DEL CONSUMIDOR (DECRETO 1/2010 DE 14 de enero) a las que puede acceder en Ramon Turró 5, Barcelona 08005.</p>' +
        '    <h4>Legislación aplicable</h4>' +
        '    <p>Las condiciones presentes se gobernarán por la legislación Española vigente. El idioma usado será el Español. <br> En el evento de tener que recurrir a los Tribunales para lidiar cualquier disputa entre las partes, esto se realizará ante las Cortes y Tribunales de la ciudad de Barcelona.</p>',
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
  },

  sendResetForm: {
    forgotPassword: `No recuerdo la contraseña`,
    errors: {
      401: `Parece que no te podemos reconocer. ¿Quizás este  no es tu email?`,
    },
  },

  thankYou: {
    title: "GRACIAS POR UTILIZAR SMART POINT GIRONA",
    text: "Lo hemos guardado",
  },

  openHub: {
    title1: "ABRIR HUB",
    title2: "EL HUB ESTÁ ABIERTO",
    text1: "Para abrir tu hub mantén presionado este botón",
    text2: "Por favor recuerda cerrar el hub",
    help: "¿NO SE ABRE? LLÁMANOS",
    addressLabel: 'Tu hub se encuentra en la dirección siguiente',
    addressLabel2: 'Asegúrate que estás delante antes de abrirlo',
  },

  crossTownDelivery: {
    title: "Envía a un amigo",
    start: {
      title: 'Te ayudamos a contactar con la gente importante de tu vida. Deja lo que quieras en el Smart Point y ' +
        'se lo llevamos a la persona que nos digas.',
      text2_li_1: 'Déjalo dentro del Smart Point',
      text2_li_2: 'Indica el teléfono de la persona a quien quieres que se lo enviemos',
      text2_li_3: 'Nosotros nos encargamos de llevarlo donde nos pida.',
    },
    cost: "COSTE DEL SERVICIO 1 EURO",

    receiverPhone: {
      title: "TELÉFONO DEL RECEPTOR",
    },

    errors: {
      // put relevant errors here (same user etc) except global ones
      // look up errors in API ShipmentController
    },

  },

  amazonReturns: {
    title: 'Devolución a Amazon',
    start: {
      title: 'Olvídate de llevar paquetes a una oficina o de esperar mensajeros',
      text2_li_1: 'Deja tu paquete en el Smart Point, sin ponerle etiqueta.',
      text2_li_2: 'Recibirás un email nuestro pidiendo que nos reenvíes la etiqueta de devolución de Amazon por email.',
      text2_li_3: 'Lo devolvemos por ti',
    },
    notesLabel: 'Información sobre la devolución',
    summary: {
      title: 'Resumen de tu devolución',
      cellSize: 'Tamaño de compartimiento',
      address: 'Ubicación de entrega',
      notes: 'Información sobre la devolución',
    },
  },

  clickAndCollect: {
    title: 'Click & Collect',
    start: {
      title: 'Vamos a cualquier tienda de Girona a buscar tus compras',
      text2_li_1: 'Compra en la tienda indicando que lo pasarás a buscar más tarde',
      text2_li_2: 'Introduce los datos del pedido en nuestra App',
      text2_li_3: 'Nosotros vamos a buscarla por ti y la dejamos en el Smart Point que nos indiques',
    },
    finish: 'Gracias',
    finish2: 'Tu pedido está en marcha. Si el repartidor necesita más información te llamará o enviará un correo. ' +
      'Una vez el paquete esté al Smart Point, recibirás un SMS para poder recogerlo.',
    errors: {
      email_sent: `Ha habido un problema enviando el email`,
    },
    typeSelector: {
      client: "Adelante",
      shop: "Sóc Tienda",
    },
    label: {
      clientName: 'Nombre del cliente',
      shopName: 'Nombre de la tienda',
      phoneNumber: 'Telèfono de usuario',
      shopAddress: 'Direccion de la tienda',
      addressToPickUp: 'Direccion donde lo hemos de recoger',
      comments: 'Información adicional para recoger la compra',
      smartpointDestination: 'Smart Point de destino:',
    },
    placeholder: {
      shopName: 'nombre',
      phoneNumber: 'telefono',
      addressToPickUp: 'direccion',
      comments: 'Numero de pedido, fecha de recogida...',
      smartpointDestination: 'Selecciona el Smart Point de destino:',
    },
  },

  clickCollectCi: {
    title: "El Corte Inglés",
    start: {
      title: 'Te traemos tu compra en El Corte Inglés <em>GRATIS</em> a tu Smart Point:',
      text2_li_1: '<a href="https://www.elcorteingles.es/">Compra online</a> e indica que irás a buscarla más tarde',
      text2_li_2: '<a href="mailto:{officeEmail}">Mándanos</a> los datos del pedido',
      text2_li_3: 'Nosotros vamos a buscarla por ti y la dejamos en el Smart Point que nos indiques',
    },

    explanation: {
      title: '¿Cómo funciona?',
      li1: 'Haz tu compra en la web de <a href="https://www.elcorteingles.es/">El Corte Inglés</a>, selecciona <b>RECOGIDA EN TIENDA / CLICK&CAR en la tienda de Girona</b>',
      li2: 'Después de comprar, indica que lo pasará a buscar SMART POINT GIRONA (teléfono {officePhone})',
      li3: 'Reenvía el correo que recibas de El Corte Inglés a <a href="mailto:{officeEmail}">{officeEmail}</a> indicando el código de usuario {code}',
      li4: 'Nosotros vamos a buscarla y una vez la tengamos lo dejaremos en el Smart Point que nos indiques.',
    },

    label:  {
      userName: 'Nombre',
      email: 'Email',
      shop: 'Tienda',
    },

    form: {
      title: 'Sumario',
      li1: 'Cuando aprietes "enviar" te remitiremos un correo electrónico con las instrucciones para utilizar el servicio.',
    },

    finish: {
      title: 'Gracias',
      text: `Te hemos enviado un email con las instrucciones para utilizar este servicio.<br/><br/>Smart Point Girona<br/>tecnología para una ciudad más verde<br/>`,
    },
  },

  profile: {
    title: 'Mi perfil',
    label: {
      first_name: 'Nombre',
      last_name: 'Apellidos',
      email: 'Email',
      isVerified: 'El número de teléfono ha sido confirmado',
      isNotVerified: 'Estamos esperando que confirmes tú número de teléfono',
      language: 'Idioma',
      phone_number: 'Número de teléfono',
      delivery_code: 'Código de envío',
      member_since: 'Miembro desde',
    },
    placeholder: {
      first_name: 'Introduce tu nombre',
      last_name: 'Introduce tus apellidos',
      email: 'Tu email',
      language: 'Idioma',
      phone_number: 'Tu número de teléfono',
      delivery_code: 'Código de envío',
      member_since: 'Miembro desde',
    },
    member_since_format: 'DD MMMM, YYYY',
    copyDeliveryCode: 'Copiar código de entrega',
    deliveryCodeCopied: 'El código se ha copiado en el portapapeles',
  },

  maps: {
    altText: "Selecciona un Smart Point",
    confirm: 'CONFIRMAR',
    back: 'VOLVER',
  },

  installApp : {
    button: "Instalar app",
  },

  // no relevant errors to show apart un sections above
  //  there global fallback ones anyway (errors.general.xxx)
  // leaving here as reference
  // selectDestination: {
  //   errors: {}
  // },

  depositItem: {
    errors: {
      ReopenTimeLimitReachedException: 'El tiempo permitido para volver a abrir ha terminado',
    },
  },

  pickupItem: {
    errors: {
      ReopenTimeLimitReachedException: 'El tiempo permitido para volver a abrir ha terminado',
    },
  },

  cancelOrder: {
    errors: {
      shipmentCantBeCancel: "Este envio no puede ser eliminado",
    },
  },
  // initStore: {
  //   errors: {}
  // },

};

export default messages;
